import { render, staticRenderFns } from "./MbSubscriptionCompleted.vue?vue&type=template&id=9a489a50&"
import script from "./MbSubscriptionCompleted.vue?vue&type=script&lang=js&"
export * from "./MbSubscriptionCompleted.vue?vue&type=script&lang=js&"
import style0 from "./MbSubscriptionCompleted.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports